import { zetApi } from '@zet/network'

export const getShareBrandURLWeb = async (
  partnerId: number,
  customerId: number,
  hash: string
) => {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash: encodeURIComponent(sessionStorage.getItem('hash') || hash),
  }
  const { data } = await zetApi.post(
    `integration/customer/generateLink/v3?customerId=${customerId}&partnerId=${partnerId}&leadSource=web`
  )
  return data?.data
}
